module.exports = __webpack_public_path__ + "img/characterAnime15.ca980847.png";